import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/reports/hoursByRates
    */
    getHoursByRate: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/reports/hoursByRate',{
            params:{
                selectedYear:options.selectedYear,
                selectedMonth:options.selectedMonth,
                selectedStatus:options.selectedStatus,
                selectedRate:options.selectedRate,
        }});
    },

    /*
        GET     /api/reports/dueByRateCategories
    */
        getDueByRateCategories: function(options){
            return axios.get( LOGUS_CONFIG.API_URL + '/reports/dueByRateCategories',{
                params:{
                    selectedYear:options.selectedYear,
                    selectedMonth:options.selectedMonth,
                    selectedRateCategory:options.selectedRateCategory,
            }});
        },


}